var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSegment06(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.92629 7.53242C7.71333 7.53242 6.73003 6.54912 6.73003 5.33616C6.73003 4.12319 7.71333 3.13989 8.92629 3.13989C10.1393 3.13989 11.1226 4.12319 11.1226 5.33616C11.1226 6.54912 10.1393 7.53242 8.92629 7.53242Z",
    fill: "#7A7A7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75772 15.1159L5.27138 8.96099L0.95009 3.09446C0.602983 2.62329 0.70363 1.95984 1.17486 1.6128C1.64603 1.26569 2.30948 1.36634 2.65652 1.83757L7.0244 7.76743C7.08625 7.77979 9.68751 8.41197 9.8416 8.47165L15.1961 3.02075C15.6062 2.60333 16.2772 2.59728 16.6947 3.0074C17.1121 3.41753 17.1181 4.08852 16.708 4.506L10.6241 10.6994C10.4612 11.3617 9.19027 16.5298 9.00343 17.2895L3.75772 15.1159Z",
    fill: "#7A7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegment06);
export default __webpack_public_path__ + "static/media/segment06.cca35d20515e0755e8a6a0cd62c72eb6.svg";
export { ForwardRef as ReactComponent };